import { Dispatch } from 'redux';
import { typedAction } from 'store/modules/base';
import {
  GETCredenciados,
  POSTCredenciadoVSEmissor,
  PATCHAprovarOuReprovarCredenciamentoEmissor,
  GETByIdCredenciado,
} from 'requests/credenciado';
import {
  AprovarOuReprovarCredenciamentoEmissorRequest,
  CommandResultTyped,
  CredenciadoEmissorRequest,
} from 'common/genericTypes';
import { CredenciadosResponse } from '../credenciados/credenciadosReponse';

export interface CredenciadoApiState {
  postCredenciadoEmissor(
    dispatch: Dispatch,
    credenciadoEmissor: CredenciadoEmissorRequest,
    stackRequest?: boolean
  ): Promise<any>;
  getCredenciados(dispatch: Dispatch, stackRequest?: boolean): Promise<CommandResultTyped<CredenciadosResponse[]>>;
  getByIdCredenciado(
    dispatch: Dispatch,
    id: string,
    stackRequest?: boolean
  ): Promise<CommandResultTyped<CredenciadosResponse>>;
  patchAprovarOuReprovarCredenciamentoEmissor(
    dispatch: Dispatch,
    id: string,
    aproveOrReproveRequest: AprovarOuReprovarCredenciamentoEmissorRequest,
    stackRequest?: boolean
  ): Promise<any>;
}

const credenciadoApiInitialState: CredenciadoApiState = {
  postCredenciadoEmissor: POSTCredenciadoVSEmissor,
  getCredenciados: GETCredenciados,
  getByIdCredenciado: GETByIdCredenciado,
  patchAprovarOuReprovarCredenciamentoEmissor: PATCHAprovarOuReprovarCredenciamentoEmissor,
};

enum CredenciadoApiActionType {
  Update = 'credenciadoApi/UPDATE',
  Reset = 'credenciadoApi/RESET',
}

export const updateCredenciadoApi = (state: CredenciadoApiState) => {
  return typedAction(CredenciadoApiActionType.Update, state);
};

export const resetCredenciadoApi = () => {
  return typedAction(CredenciadoApiActionType.Reset);
};

type CredenciadoApiAction = ReturnType<typeof updateCredenciadoApi | typeof resetCredenciadoApi>;

export function credenciadoApiReducer(
  state: CredenciadoApiState = credenciadoApiInitialState,
  action: CredenciadoApiAction
): CredenciadoApiState {
  switch (action.type) {
    case CredenciadoApiActionType.Update:
      return { ...action.payload };
    case CredenciadoApiActionType.Reset:
      return { ...credenciadoApiInitialState };
    default:
      return state;
  }
}
